import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "api/api";
import { getSurveyData } from "components/MySurveys/MySurveys.api";
import { postSuccessOps } from "components/MySurveys/utils/onSurveyFetchedSucessful";

export const useSurveyQuery = function (country, langCode, userId, searchQuery, userType) {
  const { data, isLoading, isFetching, ...rest } = useQuery(
    ["survey", country, langCode, userId, searchQuery, userType],
    () =>
      getSurveyData({
        userId,
        page: 1,
        userLangCode: langCode,
        sortColumnName: "Date",
        sortColumnOrder: "DESC",
        country,
        searchQuery,
        userType,
      }),
    {
      enabled: !!country,
      refetchOnWindowFocus: false,
      refetchInterval: (data) => data?.dailySurveyLimit?.attemptsRemaining === 0 ? 60000 : false,
      keepPreviousData: true,
      onSuccess: (result) => {
        postSuccessOps(result);
      },
    }
  );
  return {
    dailySurveyLimit: data?.dailySurveyLimit,
    surveys: data?.result.filter((survey) =>
      survey.studyName.toLowerCase().includes(searchQuery.toLowerCase())
    ),
    surveyLength: data?.result?.length,
    pages: Math.ceil(data?.result?.length / 10),
    isLoading,
    isFetching,
    ...rest,
  };
};

export const getDataa = async ({ setCountry, setLangCode, setCountryChangeMessage, auth, t }) => {
  const ipUrl = `/api/user/get-ip-details`;
  const res = await axiosClient.get(ipUrl, { timeout: 5000, });
  if (res.data.data.country.currency.code === "USD") {
    setCountry("USA");
    setLangCode("En-US");
  } else if (res.data.data.country.currency.code == "CAD") {
    setCountry("Canada");
    setLangCode("English-CA");
  } else if (res.data.data.country.currency.code == "GBP") {
    setCountry("UK");
    setLangCode("En-US");
  } else if (res.data.data.country.currency.code == "INR") {
    setCountry("India");
    setLangCode("English-IN");
  } else {
    setCountry(res.data.data.country_name);
    setLangCode(res.data.data.country_name + "-" + res.data.data.country.currency.code);
  }
  if (res && res.data) {
    if (auth?.user_country?.includes(res.data.data.country_name)) {
      setCountryChangeMessage(
        <div>
          {t("page.mysurvey.System")} <b>{res.data.data.country_name}</b> {t("page.mysurvey.country")}{" "}
          <b>{res.data.data.country_name}</b> {t("page.mysurvey.listed")}
        </div>
      );
    } else {
      setCountryChangeMessage(null);
    }
  }
};
